import Box from 'UIKit/Box/Box'
import Button from 'UIKit/Button/Button'
import { ButtonProps } from 'UIKit/Button/types'
import CircleLoader from 'UIKit/Loader/CircleLoader'
import Text from 'UIKit/Text/Text'
import { useEffect, useState } from 'react'
import { Trans } from 'react-i18next'
import { useAuth } from 'state/auth/hooks'
import styled from 'styled-components'

interface RedeemBonusActionProps {
  redeemBonus: () => Promise<boolean>
  isRedeemed: boolean
  isNotEnoughBalanceRequirement: boolean
  actionContent?: string
  percent: number
  isClaimable?: boolean
  isExpired?: boolean
}

const RedeemBonusAction: React.FC<RedeemBonusActionProps & ButtonProps> = ({
  redeemBonus,
  isRedeemed: isRedeemedDefault,
  percent,
  isClaimable,
  isExpired = false,
  isNotEnoughBalanceRequirement,
  actionContent,
  ...props
}) => {
  const { hasSession } = useAuth()
  const [submitting, setSubmitting] = useState(false)
  const [isRedeemed, setIsRedeemed] = useState(false)
  const isDisabled = isExpired || isRedeemed || !isClaimable || percent >= 100 || submitting

  useEffect(() => {
    if (isRedeemedDefault !== isRedeemed) setIsRedeemed(isRedeemedDefault)
  }, [isRedeemedDefault])

  const handleRedeemBonus = async (e) => {
    e.stopPropagation()
    setSubmitting(true)

    const result = await redeemBonus()
    if (result) setIsRedeemed(true)
    setSubmitting(false)
  }

  return (
    <StyledActionButton onClick={handleRedeemBonus} disabled={isDisabled} width="100%" {...props}>
      {submitting && (
        <Box mr="12px">
          <CircleLoader />
        </Box>
      )}

      <Text color={isDisabled ? 'textAlt1' : 'text'} fontSize={['12px', '', '14px']} fontWeight={600}>
        <Trans>
          {actionContent ||
            (isExpired
              ? 'Expired'
              : !hasSession
              ? 'Login to Redeem'
              : isRedeemed
              ? 'Redeemed'
              : isNotEnoughBalanceRequirement
              ? 'Deposit to Redeem'
              : 'Redeem bonus')}
        </Trans>
      </Text>
    </StyledActionButton>
  )
}

const StyledActionButton = styled(Button)`
  border-radius: ${({ theme: { radii } }) => radii.tiny} !important;
  height: 40px !important;

  &:disabled {
    background-color: rgba(255, 255, 255, 0.08);
  }
`

export default RedeemBonusAction
